<app-title [title]="title"></app-title>

<p>
  Στις 05/02/2018 το Ενιαίο Παλλαϊκό Μέτωπο υπέβαλε στην Εισαγγελία του Αρείου
  Πάγου μήνυση - έγκληση - συνηγορία για την αποκατάσταση της Δημοκρατίας επί τη βάσει
  τριών πραγματικών περιστατικών-παραδοχών.
</p>

<ol>
  <li>
    Τα Μνημόνια και οι αντίστοιχες Δανειακές Συμβάσεις, ουδέποτε έχουν κυρωθεί από
    την Ελληνική Βουλή, όπως επιτάσσει το άρθρο 28 παρ.1 του Συντάγματος.
  </li>
  <li>
    Μη τήρηση του αποτελέσματος του Δημοψηφίσματος της 5ης Ιουλίου του 2015, που
    σύμφωνα με το Σύνταγμα έχει δεσμευτικό και επιτακτικό χαρακτήρα.
  </li>
  <li>
    Παράδοση Νομοθετικών αρμοδιοτήτων στους ξένους δανειστές
  </li>
</ol>

<div class="media-container">
  <div class="yumpu-container">
    <iframe src="https://www.yumpu.com/xx/embed/view/fpi1JRaSnUcgldVA" frameborder="0"></iframe>
  </div>

  <div class="yumpu-container">
    <iframe src="https://www.yumpu.com/xx/embed/view/TfJIUE7aRFPBxcSk" frameborder="0"></iframe>
  </div>
</div>
